<div class="experience-scheduling-accelerator-course-assignments-view-part">
	<grid-content [setup]="setup" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="acceleratorCourseAssignments()"></grid-content>
</div>